import script from "./BtnFlotWA.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnFlotWA.vue?vue&type=script&setup=true&lang=js"

import "./BtnFlotWA.vue?vue&type=style&index=0&id=014014a2&lang=css"

const __exports__ = script;

export default __exports__